import { capitalize } from '@material-ui/core';

import {
  FilterChip,
  FilterViewerComponentProps,
} from '@spotify/confidence-core-react';

import { useIdentity } from '../../hooks';
import { IdentityAvatarMui as IdentityAvatar } from '../IdentityAvatar';

export interface IdentityFilterViewerProps
  extends FilterViewerComponentProps<string[]> {
  singularLabel: string;
  pluralLabel: string;
}

const SingleIdentity = ({
  name,
  singularLabel,
  ...props
}: { name: string; singularLabel: string } & IdentityFilterViewerProps) => {
  const { identity, isLoading } = useIdentity({ name });

  const label = (
    <span style={{ display: 'inline-flex', gap: 4 }}>
      {capitalize(singularLabel)}:{' '}
      <IdentityAvatar
        style={{ width: '1lh', height: '1lh' }}
        identityRef={identity ?? undefined}
      />{' '}
      {identity?.displayName}
    </span>
  );

  return <FilterChip {...props} label={label} loading={isLoading} />;
};

export const IdentityFilterViewer = (props: IdentityFilterViewerProps) => {
  const { value, pluralLabel } = props;

  if (value.length === 1) {
    return <SingleIdentity name={value[0]} {...props} />;
  }

  const label =
    value.length > 1
      ? `${capitalize(pluralLabel)} (${value.length})`
      : `No ${pluralLabel} selected`;

  return <FilterChip {...props} label={label} />;
};
